import React from 'react';

export const PackageHierarchyBanner = ({ compact = false }) => {
  return (
    <div className={`pkg-hierarchy-banner ${compact ? 'compact' : ''}`}>
      <div className="pkg-hierarchy-header">
        <span className="pkg-hierarchy-badge">CLINICAL STRUCTURE</span>
        <span className="pkg-hierarchy-title">Diagnostic Architecture Hierarchy</span>
      </div>

      <div className="pkg-hierarchy-flow">
        {/* Step 1: Test */}
        <div className="pkg-hierarchy-node">
          <div className="pkg-node-icon test-node">🧪</div>
          <div className="pkg-node-content">
            <span className="pkg-node-type">Individual Test</span>
            <span className="pkg-node-desc">Single analyte (e.g., Glucose, HbA1c)</span>
          </div>
        </div>

        <div className="pkg-hierarchy-arrow">➔</div>

        {/* Step 2: Profile */}
        <div className="pkg-hierarchy-node">
          <div className="pkg-node-icon profile-node">📋</div>
          <div className="pkg-node-content">
            <span className="pkg-node-type">Clinical Profile</span>
            <span className="pkg-node-desc">Reusable test group (e.g., CBC, Lipid)</span>
          </div>
        </div>

        <div className="pkg-hierarchy-arrow">➔</div>

        {/* Step 3: Package */}
        <div className="pkg-hierarchy-node active-node">
          <div className="pkg-node-icon package-node">📦</div>
          <div className="pkg-node-content">
            <span className="pkg-node-type">Health Package</span>
            <span className="pkg-node-desc">Commercial bundle of Profiles & Tests</span>
          </div>
        </div>

        <div className="pkg-hierarchy-arrow">➔</div>

        {/* Step 4: Panel */}
        <div className="pkg-hierarchy-node">
          <div className="pkg-node-icon panel-node">🏛️</div>
          <div className="pkg-node-content">
            <span className="pkg-node-type">Panel Tariff</span>
            <span className="pkg-node-desc">Contract pricing (Corporate, Cash, TPA)</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PackageHierarchyBanner;
